import globals from 'scoreboard/components/globals'
import calendars from 'scoreboard/components/calendars'

function rangeToPeriods(range = null) {
	let periods = []
	if (!range) { return periods }
	if (range.relative) {
		let targetPeriodId = globals.periodId
		if (range.calendarId) {
			targetPeriodId = calendars.correspondingPeriod(range.calendarId, targetPeriodId).id
		}
		periods = calendars.relativePeriods(targetPeriodId, range.first, range.last) || []
	} else {
		periods = calendars.periodSublist(range.first, range.last) || []
	}
	return periods
}

export default rangeToPeriods
rangeToPeriods.__filename__ = 'reports/common/range-to-periods.js'
